import { render, staticRenderFns } from "./Expatriado.vue?vue&type=template&id=54cdd814&scoped=true&"
import script from "./Expatriado.vue?vue&type=script&lang=js&"
export * from "./Expatriado.vue?vue&type=script&lang=js&"
import style0 from "./Expatriado.vue?vue&type=style&index=0&id=54cdd814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cdd814",
  null
  
)

export default component.exports